/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { DownloadTransactionsAction, DownloadTransactionsActionTypes, DownloadTransactionsFilter } from './actions';

export interface DownloadTransactionsState {
  filter?: DownloadTransactionsFilter;
  error?: Error;
  loading?: boolean;
  searchString: string;
  startDate?: Date;
  endDate?: Date;
  initiateTransactionsExportResponseId?: string;
  url?: string;
  locale?: string;
}

let nowDate = new Date();

let lastSevenDayDate = new Date();
lastSevenDayDate.setDate(nowDate.getDate() - 7);

export const initialDownloadTransactionsState: DownloadTransactionsState = {
  filter: {},
  loading: false,
  searchString: '',
  startDate: lastSevenDayDate,
  endDate: nowDate,
  initiateTransactionsExportResponseId: '',
  url: '',
  locale: 'RU',
};

export default function downloadTransactionsReducer(
  state = initialDownloadTransactionsState,
  action: DownloadTransactionsAction,
) {
  switch (action.type) {
    case DownloadTransactionsActionTypes.DOWNLOAD_TRANSACTIONS_REQUEST:
      const { filter, searchString } = action;

      return update(state, {
        $unset: ['error'],
        loading: { $set: true },
      });

    case DownloadTransactionsActionTypes.DOWNLOAD_TRANSACTIONS_SUCCESS:
      return update(state, {
        initiateTransactionsExportResponseId: { $set: action.id },
        url: { $set: action.url },
      });

    case DownloadTransactionsActionTypes.DOWNLOAD_TRANSACTIONS_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    case DownloadTransactionsActionTypes.DOWNLOAD_TRANSACTIONS_ERROR_RESET:
      return update(state, {
        error: { $set: null },
      });

    case DownloadTransactionsActionTypes.DOWNLOAD_TRANSACTIONS_RESET:
      return initialDownloadTransactionsState;

    case DownloadTransactionsActionTypes.DISABLE_SUBSCRIPTION:
      return update(state, {
        loading: { $set: false },
      });

    default:
      return state;
  }
}
